export default text => {
  if (typeof window === "undefined") return;
  window.open("data:application/txt," + encodeURIComponent(text), "_self");
};
